/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


class Dialog {
    constructor(settings = {}) {
        this.settings = Object.assign(
            {
                accept: 'OK',
                bodyClass: 'dialog-open',
                cancel: 'Cancel',
                dialogClass: '',
                message: '',
                soundAccept: '',
                soundOpen: '',
                template: ''
            },
            settings
        )
        this.init()
    }

    collectFormData(formData) {
        const object = {};
        formData.forEach((value, key) => {
            if (!Reflect.has(object, key)) {
                object[key] = value
                return
            }
            if (!Array.isArray(object[key])) {
                object[key] = [object[key]]
            }
            object[key].push(value)
        })
        return object
    }

    getFocusable() {
        return [...this.dialog.querySelectorAll('button,[href],select,textarea,input:not([type="hidden"]),[tabindex]:not([tabindex="-1"])')]
    }

    init() {
        this.dialogSupported = typeof HTMLDialogElement === 'function'
        this.dialog = document.createElement('dialog')
        this.dialog.role = 'dialog'
        this.dialog.dataset.component = this.dialogSupported ? 'dialog' : 'no-dialog';
        this.dialog.innerHTML = `
    <form method="dialog" data-ref="form">
      <fieldset data-ref="fieldset" role="document">
        <legend data-ref="message" id="${(Math.round(Date.now())).toString(36)}"></legend>
        <div data-ref="template"></div>
      </fieldset>
      <menu>
        <button${this.dialogSupported ? '' : ` type="button"`} data-ref="cancel" value="cancel"></button>
        <button${this.dialogSupported ? '' : ` type="button"`} data-ref="accept" value="default"></button>
      </menu>
      <audio data-ref="soundAccept"></audio>
      <audio data-ref="soundOpen"></audio>
    </form>`
        document.body.appendChild(this.dialog)

        this.elements = {}
        this.focusable = []
        this.dialog.querySelectorAll('[data-ref]').forEach(el => this.elements[el.dataset.ref] = el)
        this.dialog.setAttribute('aria-labelledby', this.elements.message.id)
        this.elements.cancel.addEventListener('click', () => { this.dialog.dispatchEvent(new Event('cancel')) })
        this.dialog.addEventListener('keydown', e => {
            if (e.key === 'Enter') {
                if (!this.dialogSupported) e.preventDefault()
                this.elements.accept.dispatchEvent(new Event('click'))
            }
            if (e.key === 'Escape') this.dialog.dispatchEvent(new Event('cancel'))
            if (e.key === 'Tab') {
                e.preventDefault()
                const len =  this.focusable.length - 1;
                let index = this.focusable.indexOf(e.target);
                index = e.shiftKey ? index - 1 : index + 1;
                if (index < 0) index = len;
                if (index > len) index = 0;
                this.focusable[index].focus();
            }
        })
        this.toggle()
    }

    open(settings = {}) {
        const dialog = Object.assign({}, this.settings, settings)
        this.dialog.className = dialog.dialogClass || 'custom_diag'
        this.elements.accept.innerText = dialog.accept
        this.elements.cancel.innerText = dialog.cancel
        this.elements.cancel.hidden = dialog.cancel === ''
        this.elements.message.innerText = dialog.message
        this.elements.soundAccept.src = dialog.soundAccept || ''
        this.elements.soundOpen.src = dialog.soundOpen || ''
        this.elements.target = dialog.target || ''
        this.elements.template.innerHTML = dialog.template || ''

        this.focusable = this.getFocusable()
        this.hasFormData = this.elements.fieldset.elements.length > 0

        if (dialog.soundOpen) {
            this.elements.soundOpen.play()
        }

        this.toggle(true)

        if (this.hasFormData) {
            this.focusable[0].focus()
            this.focusable[0].select()
        }
        else {
            this.elements.accept.focus()
        }
    }

    toggle(open = false) {
        if (this.dialogSupported && open) this.dialog.showModal()
        if (!this.dialogSupported) {
            document.body.classList.toggle(this.settings.bodyClass, open)
            this.dialog.hidden = !open
            if (this.elements.target && !open) {
                this.elements.target.focus()
            }
        }
    }

    waitForUser() {
        return new Promise(resolve => {
            this.dialog.addEventListener('cancel', () => {
                this.toggle()
                resolve(false)
            }, { once: true })
            this.elements.accept.addEventListener('click', () => {
                let value = this.hasFormData ? this.collectFormData(new FormData(this.elements.form)) : true;
                if (this.elements.soundAccept.getAttribute('src').length > 0) this.elements.soundAccept.play()
                this.toggle()
                resolve(value)
            }, { once: true })
        })
    }

    alert(message, config = { target: event.target }) {
        const settings = Object.assign({}, config, { cancel: '', message, template: '' })
        this.open(settings)
        return this.waitForUser()
    }

    confirm(message, config = { target: event.target }) {
        const settings = Object.assign({}, config, { message, template: '' })
        this.open(settings)
        return this.waitForUser()
    }

    prompt(message, value, config = { target: event.target }) {
        const template = `<label aria-label="${message}"><input type="text" name="prompt" value="${value}"></label>`
        const settings = Object.assign({}, config, { message, template })
        this.open(settings)
        return this.waitForUser()
    }
}


async function recalcCart() {
    const cartContents = await fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            return data
        });
    //console.debug(cartContents)

    const depths = cartContents.items.map((el) => {
        const matches = el.title.match(/([^x]+)x([^x]+)x(\d+) /);
        if (matches && matches.length > 3)
            return matches[3]
    })
    const colors = cartContents.items.map((el) => {
        if (el.title.indexOf('Cream') !== -1) return 'Cream';
        if (el.title.indexOf('Maple') !== -1) return 'Maple';

        const options = el.options_with_values.filter((el) => el.name === 'Color');
        //console.log('options:', options);
        if (options.length > 0) {
            return options[0].value;
        }
    })
    const unique = depths.filter((el) => el !== undefined).filter(onlyUnique);
    const uniqueColors = colors.filter((el) => el !== undefined).filter(onlyUnique);
    //console.log('unique:', unique);
    //console.log('colors:', uniqueColors);
    if ((unique.length > 1 || uniqueColors.length > 1)) {

        document.querySelector('.cart__checkout.btn').setAttribute('disabled', 'disabled');

        let div;
        if (!document.querySelector('.cart-alert')) {
            div = document.createElement('div');
            div.classList.add('cart-alert');
        } else {
            div = document.querySelector('.cart-alert');
            div.innerHTML = '';
        }

        const label = document.createElement('p');
        label.innerHTML = 'Are you sure you want to mix colors and/or depths of your spice racks?';
        const btn = document.createElement('button');
        btn.innerHTML = 'Continue';
        btn.classList.add('btn');
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            document.querySelector('.cart__checkout.btn').removeAttribute('disabled');
            div.classList.add('hidden');
        })
        div.append(label);
        label.after(btn);
        document.querySelector('.cart__buttons-wrapper .cart__buttons').prepend(div);

        // .cart__buttons-wrapper .cart__buttons
    } else {
        document.querySelector('.cart__checkout.btn').removeAttribute('disabled');
        if (document.querySelector('.cart-alert'))
            document.querySelector('.cart-alert').remove();
    }
}

async function cartHasDepth14() {
    const cartContents = await fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            return data
        });
    //console.debug(cartContents)

    const depths = cartContents.items.map((el) => {
        const matches = el.title.match(/([^x]+)x([^x]+)x(\d+) /);
        if (matches && matches.length > 3)
            return matches[3]
    })

    const unique = depths.filter((el) => el !== undefined).filter(onlyUnique).filter((el) => el === '14');
    if (unique.length > 0) {
        return true;
    }
    return false;
}

function isDepth14InTitle(title) {
    const matches = title.match(/([^x]+)x([^x]+)x(\d+) /);
    if (matches && matches.length > 3 && matches[3] === '14')
        return true;
    return false;
}

const dialog = new Dialog();
let is_confirmed = false;

(function () {
    // Add custom code below this line

    const productSubmitBtn = document.querySelector('.product__submit__add');
    if (productSubmitBtn) {
        productSubmitBtn.addEventListener('click', function (e) {
            const product_title = document.querySelector('.product__title').innerText;
            const sessionKey = 'confirmed_14' ;// + product_title
            const alreadyConfirmed = sessionStorage.getItem(sessionKey);
            if (!alreadyConfirmed && isDepth14InTitle(product_title)) {
                // show confirm dialog
                e.preventDefault();
                e.stopPropagation();

                dialog.confirm('The x14 units are 13.8” in depth, this is a non-standard depth. Please verify you measured and know they will fit. Do you want to continue?')
                    .then((res) => {
                        console.log(res)
                        if (res) {
                            sessionStorage.setItem(sessionKey, 'true');
                            is_confirmed = true;
                            e.target.click();
                        }
                    })

            } else {
                is_confirmed = false;
            }
        });
    }

    document.querySelectorAll('[type="radio"]').forEach(el => el.addEventListener('change', function (e) {
        const val = e.target.value;
        const parent = e.target.closest('.radio__fieldset');

        if (_learnq && window.location.href.indexOf('/products/') !== -1) {
            setTimeout(function () {
                const images = document.querySelector('.product-single__media-slide.is-selected img');
                let image = null
                if (images) {
                    image = images.src
                }
                const URL = window.location.href
                const urlParts = URL.split("variant=")
                const variant_id = document.querySelector('.form [name="id"]')?.value;

                const dd = {
                    variant_id: variant_id,
                    id: document.querySelector('[name="product-id"]') ? document.querySelector('[name="product-id"]').value : '',
                    title: document.querySelector('h1.product__title') ? document.querySelector('h1.product__title').innerText : '',
                    price: document.querySelector('.product__price--regular') ? document.querySelector('.product__price--regular').innerText : '',
                    image: image,
                    URL: urlParts && urlParts[0] && (urlParts[0].trim().replace('?', '') + '?variant=' + variant_id),
                };

                console.log(dd);

                _learnq.push(['track', 'Viewed Variant', dd]);
            }, 650)
        }

    }));

    document.querySelectorAll('[name^="options"]').forEach(el => el.addEventListener('change', function (e) {
        const val = e.target.value;
        const parent = e.target.closest('.radio__fieldset');
        parent.querySelector('.label_value').innerHTML = val;
    }));

    document.addEventListener('theme:cart:open', function (e) {
        console.log('recalc cart');
        recalcCart();
    });

    document.addEventListener('theme:cart:loaded', function (e) {
        console.log('recalc cart');
        recalcCart();
    });

    document.addEventListener('theme:cart:refresh', function (e) {
        console.log('recalc cart');
        recalcCart();
    });

    document.addEventListener('theme:cart:added', function (e) {
        console.log('recalc cart');
        recalcCart();
    });

    document.addEventListener('theme:cart:update', function (e) {
        console.log('recalc cart');
        recalcCart();
    });

    document.addEventListener('rebuy:smartcart.show', (event) => {
        const smartcart = event.detail.smartcart;

        //console.log('rebuy:smartcart.show: smartcart', smartcart);
        //console.log('recalc cart');
        recalcCart();
    });

    document.addEventListener('click', function (e) {
        //e.preventDefault();
        if (e.target.classList.contains('vs-modal')) {
            modal.style.display = "none";
        }
    })

    if (document.querySelector('.cart__checkout.btn')) {
        // get cart contents and parse them to see if we have multiple depth sizes
        recalcCart();

    }

    var closeModalBtn = document.getElementsByClassName("vs-close")[0];

    closeModalBtn.onclick = function () {
        modal.style.display = "none";
    }

    // Get the modal
    var modal = document.getElementById("myModal");

    var modalImg = document.getElementById("img01");
    var captionText = document.getElementById("vs-caption");

    document.querySelectorAll('.modal-image').forEach((el) => {
        el.addEventListener('click', function (e) {
            e.preventDefault();
            modal.style.display = "block";
            modalImg.src = this.href;
            captionText.innerHTML = this.title;
        })
    });

    document.querySelectorAll('[name="options[Color]"]').forEach((el) => {
        el.addEventListener('click', function (e) {
            const color = e.target.value;
            if (!document.querySelector('.product__title span')) {
                const span = document.createElement('span');
                document.querySelector('.product__title').append(span);
            }

            if (document.querySelector('.product__title span') && color) {
                document.querySelector('.product__title span').innerHTML = ' - ' + color;
            }
        })
    })


    const quantityContainer = document.querySelector(".quantity");
    if (quantityContainer) {
        const minusBtn = quantityContainer.querySelector(".minus");
        const plusBtn = quantityContainer.querySelector(".plus");
        const inputBox = quantityContainer.querySelector(".input-box");

        updateButtonStates();

        quantityContainer.addEventListener("click", handleButtonClick);
        inputBox.addEventListener("input", handleQuantityChange);

        function updateButtonStates() {
            const value = parseInt(inputBox.value);
            minusBtn.disabled = value <= 1;
            plusBtn.disabled = value >= parseInt(inputBox.max);
        }

        function handleButtonClick(event) {
            if (event.target.classList.contains("minus")) {
                decreaseValue();
            } else if (event.target.classList.contains("plus")) {
                increaseValue();
            }
        }

        function decreaseValue() {
            let value = parseInt(inputBox.value);
            value = isNaN(value) ? 1 : Math.max(value - 1, 1);
            inputBox.value = value;
            updateButtonStates();
            handleQuantityChange();
        }

        function increaseValue() {
            let value = parseInt(inputBox.value);
            value = isNaN(value) ? 1 : Math.min(value + 1, parseInt(inputBox.max));
            inputBox.value = value;
            updateButtonStates();
            handleQuantityChange();
        }

        function handleQuantityChange() {
            let value = parseInt(inputBox.value);
            value = isNaN(value) ? 1 : value;

            // Execute your code here based on the updated quantity value
            console.log("Quantity changed:", value);
        }
    }


    document.querySelectorAll('.q-wrap .q-header, .q-wrap .plus-minus-toggle').forEach((el) => {
        el.addEventListener('click', function (e) {
            const parent = e.target.closest('.q-wrap');
            parent.classList.toggle('active');
        })
    })

    // Quiz iframe cart sync - notify quiz when cart is updated or cleared
    function notifyQuizOfCartUpdate() {
        const quizIframe = document.getElementById('quiz-iframe');

        if (!quizIframe) {
            console.log('📊 Quiz iframe not found on this page');
            return;
        }

        fetch('/cart.js')
            .then(response => response.json())
            .then(data => {
                console.log('📤 Cart data fetched, item count:', data.item_count);
                console.log('📤 Cart items:', data.items);

                if (quizIframe.contentWindow) {
                    console.log('📤 Sending full cart data to quiz iframe');

                    // Send full cart data including items array
                    quizIframe.contentWindow.postMessage({
                        type: 'cartUpdated',
                        itemCount: data.item_count,
                        items: data.items // Include full items array with variant IDs and quantities
                    }, 'https://shopify-custom-quiz-app.vercel.app');

                    // If cart is empty, also send cartCleared message
                    if (data.item_count === 0) {
                        console.log('🗑️ Cart is empty, sending cartCleared message');
                        quizIframe.contentWindow.postMessage({
                            type: 'cartCleared'
                        }, 'https://shopify-custom-quiz-app.vercel.app');
                    }
                } else {
                    console.warn('⚠️ Quiz iframe contentWindow not accessible');
                }
            })
            .catch(err => console.error('❌ Error fetching cart:', err));
    }

    // Listen to all cart events and notify quiz
    console.log('🎯 Setting up cart event listeners for quiz sync');
    document.addEventListener('theme:cart:update', function() {
        console.log('🔔 theme:cart:update event fired');
        notifyQuizOfCartUpdate();
    });
    document.addEventListener('theme:cart:refresh', function() {
        console.log('🔔 theme:cart:refresh event fired');
        notifyQuizOfCartUpdate();
    });
    document.addEventListener('theme:cart:loaded', function() {
        console.log('🔔 theme:cart:loaded event fired');
        notifyQuizOfCartUpdate();
    });


    // ^^ Keep your scripts inside this IIFE function call to
    // avoid leaking your variables into the global scope.
})();

function onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
}

// B2B wholesale promo bar override
(function () {
  const tags = globalThis.vsCustomerTags || [];
  if (!tags.includes('b2b')) return;

  let discountPct = 0;
  if (tags.includes('b2b-wholesale30')) discountPct = 30;
  else if (tags.includes('b2b-wholesale25')) discountPct = 25;
  else if (tags.includes('b2b-wholesale20')) discountPct = 20;

  if (!discountPct) return;

  const THRESHOLD = 10000; // $100.00 in cents
  const GREEN = 'rgb(80, 135, 49)';
  const GRAY = 'rgb(152, 162, 179)';

  function makeIconSvg(color) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 22 22');
    svg.setAttribute('fill', 'none');
    const c1 = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    c1.setAttribute('cx', '11'); c1.setAttribute('cy', '11'); c1.setAttribute('r', '10');
    c1.setAttribute('fill', color); c1.setAttribute('stroke', color); c1.setAttribute('stroke-width', '2');
    const c2 = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    c2.setAttribute('cx', '11'); c2.setAttribute('cy', '11'); c2.setAttribute('r', '6');
    c2.setAttribute('fill', color); c2.setAttribute('stroke', 'white'); c2.setAttribute('stroke-width', '2');
    svg.appendChild(c1);
    svg.appendChild(c2);
    return svg;
  }

  function makeIconEl(label, color, posStyle, unlocked) {
    const wrap = document.createElement('div');
    wrap.className = 'kaching-cart__tiered-promotions-bar-icon' + (unlocked ? ' kaching-cart__tiered-promotions-bar-icon--unlocked' : '');
    wrap.setAttribute('style', posStyle);
    wrap.appendChild(makeIconSvg(color));
    const tooltip = document.createElement('div');
    tooltip.className = 'kaching-cart__tiered-promotions-bar-icon-tooltip';
    tooltip.setAttribute('style', posStyle.includes('flex-end') ? 'align-items: flex-end; text-align: right;' : 'align-items: center; text-align: center;');
    const title = document.createElement('span');
    title.className = 'kaching-cart__tiered-promotions-bar-icon-tooltip-title';
    title.style.color = color;
    title.textContent = label;
    tooltip.appendChild(title);
    wrap.appendChild(tooltip);
    return wrap;
  }

  function buildPromoBar(cartTotal) {
    const progress = Math.min(100, (cartTotal / THRESHOLD) * 100);
    const remaining = Math.max(0, THRESHOLD - cartTotal);
    const remainingDollars = (remaining / 100).toFixed(2);
    const discountUnlocked = cartTotal >= THRESHOLD;
    const discountColor = discountUnlocked ? GREEN : GRAY;

    const frag = document.createDocumentFragment();

    // Text line
    const p = document.createElement('p');
    p.className = 'kaching-cart__tiered-promotions-bar-text';
    const span = document.createElement('span');
    if (discountUnlocked) {
      const s1 = document.createElement('strong'); s1.textContent = 'Free shipping';
      const s2 = document.createElement('strong'); s2.textContent = `${discountPct}% off`;
      span.appendChild(s1);
      span.appendChild(document.createTextNode(' and '));
      span.appendChild(s2);
      span.appendChild(document.createTextNode(' unlocked!'));
    } else {
      const s1 = document.createElement('strong'); s1.textContent = 'Free shipping';
      const s2 = document.createElement('strong'); s2.textContent = `$${remainingDollars}`;
      const s3 = document.createElement('strong'); s3.textContent = `${discountPct}% off`;
      span.appendChild(s1);
      span.appendChild(document.createTextNode(' unlocked! Add '));
      span.appendChild(s2);
      span.appendChild(document.createTextNode(' more to unlock '));
      span.appendChild(s3);
      span.appendChild(document.createTextNode('!'));
    }
    p.appendChild(span);
    frag.appendChild(p);

    // Progress container
    const container = document.createElement('div');
    container.className = 'kaching-cart__tiered-promotions-bar-progress-container';
    container.setAttribute('dir', '');

    const icons = document.createElement('div');
    icons.className = 'kaching-cart__tiered-promotions-bar-icons';
    icons.appendChild(makeIconEl(
      'Free shipping', GREEN,
      'left: 50%; transform: translateX(-50%); align-items: center; text-align: center; max-width: 33%;',
      true
    ));
    icons.appendChild(makeIconEl(
      `${discountPct}% off`, discountColor,
      'right: -2px; align-items: flex-end; text-align: right; max-width: 33%;',
      discountUnlocked
    ));
    container.appendChild(icons);

    const fill = document.createElement('div');
    fill.className = 'kaching-cart__tiered-promotions-bar-progress-fill';
    fill.setAttribute('dir', 'ltr');
    fill.setAttribute('data-progress-percentage', String(progress));
    fill.setAttribute('style', `width: ${progress}%; direction: ltr !important; unicode-bidi: isolate !important; text-align: left !important;`);
    fill.textContent = '\u00a0';
    container.appendChild(fill);

    frag.appendChild(container);
    return frag;
  }

  function overrideBar(bar) {
    if (bar._vsUpdating) return;
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        bar._vsUpdating = true;
        while (bar.firstChild) bar.removeChild(bar.firstChild);
        bar.appendChild(buildPromoBar(cart.total_price));
        bar._vsUpdating = false;
        watchBarContent(bar);
      });
  }

  const watchedBars = new WeakSet();

  function watchBarContent(bar) {
    if (watchedBars.has(bar)) return;
    watchedBars.add(bar);
    const inner = new MutationObserver(() => {
      if (!bar._vsUpdating) overrideBar(bar);
    });
    inner.observe(bar, { childList: true, subtree: true });
  }

  function initBarObserver() {
    const existing = document.querySelector('.kaching-cart__tiered-promotions-bar');
    if (existing) overrideBar(existing);

    const outer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          const bar = node.classList && node.classList.contains('kaching-cart__tiered-promotions-bar')
            ? node
            : node.querySelector && node.querySelector('.kaching-cart__tiered-promotions-bar');
          if (bar) overrideBar(bar);
        });
      });
    });
    outer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBarObserver);
  } else {
    initBarObserver();
  }
})();

// B2B cart: hide theme cart drawer and redirect toggles to SparkLayer cart
(function () {
  const tags = globalThis.vsCustomerTags || [];
  if (!tags.includes('b2b')) return;

  function openSparkCart() {
    // 1. Click the hidden [data-spark-link=cart] button SparkLayer binds to
    const sparkTrigger = document.getElementById('vs-spark-cart-trigger');
    if (sparkTrigger) { sparkTrigger.click(); return; }

    // 2. SparkLayer global API
    if (globalThis.Spark?.openCart) { globalThis.Spark.openCart(); return; }

    // 3. spark-cart custom element
    const sparkCart = document.querySelector('spark-cart');
    if (sparkCart) {
      if (typeof sparkCart.show === 'function') { sparkCart.show(); return; }
      if (typeof sparkCart.open === 'function') { sparkCart.open(); return; }
      sparkCart.setAttribute('open', '');
      return;
    }

    // 4. spark-drawer web component
    const drawer = document.querySelector('spark-drawer');
    if (drawer) {
      if (typeof drawer.show === 'function') { drawer.show(); return; }
      if (typeof drawer.open === 'function') { drawer.open(); return; }
      drawer.setAttribute('open', '');
      return;
    }

    // 5. Custom events as last resort
    document.dispatchEvent(new CustomEvent('spark:cart:open', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('sparklayer:cart:open', { bubbles: true }));
  }

  function initB2BCart() {
    // Hide the theme cart drawer
    const themeDrawer = document.getElementById('cart-drawer');
    if (themeDrawer) themeDrawer.style.display = 'none';

    // Open SparkLayer cart when the inline early-blocker signals us
    document.addEventListener('vs:b2b:cart:open', () => openSparkCart());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initB2BCart);
  } else {
    initB2BCart();
  }
})();

// B2B: SparkLayer add-to-cart helper + cart count badge + global fetch interceptor
(function () {
  const tags = globalThis.vsCustomerTags || [];
  if (!tags.includes('b2b')) return;

  const SL_GQL = '/tools/sparklayer/graphql?siteId=verticalspice&v=1.36.16';
  const SL_MUTATION = 'mutation updateCart($products:[CartItemInput]){updateCart(products:$products){results{messages{type}sku name}cart{cartUuid items{quantity}total{gross currencyCode}}}}';
  const SL_CART_QUERY = '{cart{items{quantity}}}';

  // ── Cart count badge ──────────────────────────────────────────────────────

  function getCartCountEl() {
    const anchor = document.querySelector('.nav-v-bar__icon--cart');
    if (!anchor) return null;
    let badge = anchor.querySelector('.nav-v-bar__cart-count');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'nav-v-bar__cart-count';
      anchor.appendChild(badge);
    }
    return badge;
  }

  function setCartCount(n) {
    const badge = getCartCountEl();
    if (!badge) return;
    if (n > 0) {
      badge.textContent = n;
      badge.style.display = '';
    } else {
      badge.style.display = 'none';
    }
  }

  function fetchSlCartCount() {
    return fetch(SL_GQL, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'site-id': 'verticalspice' },
      body: JSON.stringify({ query: SL_CART_QUERY }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        const items = data?.data?.cart?.items || [];
        const total = items.reduce(function (s, i) { return s + (i.quantity || 0); }, 0);
        setCartCount(total);
        return total;
      });
  }

  // Fetch count on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchSlCartCount);
  } else {
    fetchSlCartCount();
  }

  // ── Shared authenticated fetch to SparkLayer GQL ─────────────────────────
  // spark.fetch handles JWT/impersonation; raw fetch is fallback with matching body shape.
  function slFetch(vars) {
    if (window.spark && typeof window.spark.fetch === 'function') {
      return Promise.resolve()
        .then(function () { return window.spark.fetch(SL_MUTATION, vars); })
        .catch(function () { return slFetchRaw(vars); });
    }
    return slFetchRaw(vars);
  }

  function slFetchRaw(vars) {
    var body = { query: SL_MUTATION, variables: Object.assign({ impersonatingCustomerId: null }, vars) };
    var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json', 'site-id': 'verticalspice' };
    // Use SparkLayer token from localStorage if available (may avoid app-proxy auth issues)
    try {
      var d = JSON.parse(localStorage.getItem('sparkLayerData') || '{}');
      if (d.access_token && parseInt(d.expires_at, 10) > Date.now()) {
        headers['Authorization'] = 'Bearer ' + d.access_token;
      }
    } catch (e) {}
    return fetch(SL_GQL, { method: 'POST', credentials: 'include', headers: headers, body: JSON.stringify(body) });
  }

  function handleCartResponse(data) {
    const items = data?.data?.updateCart?.cart?.items || [];
    if (items.length) {
      const total = items.reduce(function (s, i) { return s + (i.quantity || 0); }, 0);
      setCartCount(total);
    } else {
      fetchSlCartCount();
    }
    return data;
  }

  // ── Add-to-cart helper ────────────────────────────────────────────────────

  window.vsB2BAddToCart = function (sku, qty) {
    return slFetch({ products: [{ sku: String(sku), adjustQuantity: qty || 1 }] })
      .then(function (r) { return r.json(); })
      .then(handleCartResponse);
  };

  // ── Batch add-to-cart (all products in one mutation) ─────────────────────
  window.vsB2BAddManyToCart = function (products) {
    return slFetch({
      products: products.map(function (p) {
        return { sku: String(p.sku), adjustQuantity: p.qty || 1 };
      }),
    })
      .then(function (r) { return r.json(); })
      .then(handleCartResponse);
  };

  // ── Variant-ID → SKU map (populated by sections) ─────────────────────────
  window.vsVariantToSku = window.vsVariantToSku || {};

  // ── Intercept fetch-based /cart/add.js calls ──────────────────────────────
  const _fetch = window.fetch;
  window.fetch = function (url, opts) {
    if (
      typeof url === 'string' &&
      /\/cart\/add(\.js)?(\?|$)/.test(url) &&
      opts && opts.body
    ) {
      try {
        const body = typeof opts.body === 'string' ? JSON.parse(opts.body) : null;
        if (body && body.items && body.items.length) {
          const mapped = [];
          const allFound = body.items.every(function (item) {
            const sku = window.vsVariantToSku[String(item.id)];
            if (sku) { mapped.push({ sku, qty: item.quantity || 1 }); return true; }
            return false;
          });
          if (allFound) {
            const calls = mapped.map(function (m) { return window.vsB2BAddToCart(m.sku, m.qty); });
            return Promise.all(calls).then(function () {
              document.dispatchEvent(new Event('theme:cart:refresh'));
              return new Response(JSON.stringify({ items: body.items }), {
                status: 200,
                headers: { 'Content-Type': 'application/json' },
              });
            });
          }
        }
      } catch (_) {}
    }
    return _fetch.apply(window, arguments);
  };
})();

// B2C mobile: hide floating widgets when cart drawer opens; B2B: tag body
(function() {
  var tags = window.vsCustomerTags || [];
  var isB2B = tags.indexOf('b2b') !== -1;
  if (isB2B) {
    var addB2BClass = function() { document.body.classList.add('vs-b2b'); };
    if (document.body) { addB2BClass(); } else { document.addEventListener('DOMContentLoaded', addB2BClass); }
    return;
  }
  var SELECTORS = ['.vf-container.vf-container__minimized', '.chatra--mobile-widget'];
  var hidden = [];
  document.addEventListener('theme:cart:open', function() {
    if (window.innerWidth > 768) return;
    hidden = [];
    SELECTORS.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        hidden.push({ el: el, prev: el.style.display });
        el.style.display = 'none';
      });
    });
  });
  document.addEventListener('theme:cart:close', function() {
    hidden.forEach(function(item) { item.el.style.display = item.prev; });
    hidden = [];
  });
})();

// ── BSS wholesale cart: keep Kaching out of the cart/checkout so BSS controls pricing ──
// Wholesale customers (tag `wholesale`, NOT `b2b`) must not get Kaching's drawer or its
// discount code. Kaching applies a Shopify discount CODE (KCART) via its own front-end JS,
// which then occupies the checkout discount slot so BSS "Custom Pricing" never lands
// (two product discounts can't stack on one item). Fix: route wholesale customers to the
// native /cart page (it carries BSS pricing attrs + goes through the native checkout where
// BSS applies), hide Kaching's drawer (CSS), and neutralise Kaching's discount-code call.
(function () {
  if (!window.vsWholesale) return;

  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

  // Tag <body> so `.vs-wholesale kaching-cart { display:none }` (custom.css) applies.
  var addCls = function () { if (document.body) document.body.classList.add('vs-wholesale'); };
  if (document.body) { addCls(); } else { document.addEventListener('DOMContentLoaded', addCls); }

  // 1) Cart icon / drawer toggles / Kaching checkout button -> native /cart page.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var t = e.target.closest(
      '[data-cart-drawer-toggle],[aria-controls="cart-drawer"],.nav-v-bar__icon--cart,[data-kaching-checkout],a[href$="/cart"],a[href*="/cart?"]'
    );
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = cartUrl;
  }, true);

  // 2) Money backstop: stop Kaching applying its discount code. It adds codes via the
  //    Storefront API `cartDiscountCodesUpdate` mutation; force discountCodes to empty for
  //    wholesale so no KCART code lands. Primary money lever is still the Kaching-side
  //    promotion exclusion; this is a belt-and-suspenders guard. Retail is unaffected
  //    (whole module is gated on window.vsWholesale).
  var _fetch = window.fetch;
  if (typeof _fetch === 'function') {
    window.fetch = function (url, opts) {
      try {
        if (opts && typeof opts.body === 'string' && opts.body.indexOf('cartDiscountCodesUpdate') !== -1) {
          var parsed = JSON.parse(opts.body);
          if (parsed && parsed.variables && 'discountCodes' in parsed.variables) {
            parsed.variables.discountCodes = [];
            opts = Object.assign({}, opts, { body: JSON.stringify(parsed) });
          }
        }
      } catch (_) {}
      // Add-to-cart: Kaching's drawer is hidden for wholesale, so instead of a hidden
      // drawer + a dimmed page, send them straight to the native /cart page (BSS prices).
      var u = (typeof url === 'string') ? url : (url && url.url) || '';
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(u) && opts && opts.body;
      var p = _fetch.apply(this, [url, opts]);
      if (isAdd) {
        return p.then(function (res) {
          try { window.location.href = cartUrl; } catch (_) {}
          return res;
        });
      }
      return p;
    };
  }

  // 3) Fallback for non-fetch (XHR) add-to-cart: watch cart events -> go to /cart.
  ['theme:cart:added', 'cart:added', 'product:added'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      if (location.pathname.replace(/\/$/, '') !== (cartUrl.replace(/^https?:\/\/[^/]+/, '') || '/cart').replace(/\/$/, '')) {
        window.location.href = cartUrl;
      }
    });
  });
})();


